var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7574 6.34367C7.36688 5.95315 6.73371 5.95315 6.34319 6.34367C5.95266 6.7342 5.95266 7.36736 6.34319 7.75789L10.5858 12.0005L6.34319 16.2432C5.95266 16.6337 5.95266 17.2669 6.34319 17.6574C6.73371 18.0479 7.36688 18.0479 7.7574 17.6574L12 13.4147L16.2427 17.6574C16.6332 18.0479 17.2664 18.0479 17.6569 17.6574C18.0474 17.2669 18.0474 16.6337 17.6569 16.2432L13.4143 12.0005L17.6569 7.7579C18.0474 7.36737 18.0474 6.73421 17.6569 6.34369C17.2664 5.95316 16.6332 5.95316 16.2427 6.34369L12 10.5863L7.7574 6.34367Z",
    fill: "#121724",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.404da42c43236a59d4d106b49e4de095.svg";
export { ForwardRef as ReactComponent };